import QuestionLabel from './QuestionLabel';
import React, { useEffect } from 'react';
import SelectItemButton from './components/SelectItemButton.jsx';
import { usePublicPackagesQuery } from '../../../lib/SharedQueries.js';
import Loading from '../../Loading';
import { formatCurrency } from '../../../lib/CurrencyHelpers.js';
import { humanRenewalPeriod } from '~/lib/PackageHelpers';
import { FormPart, part } from '~/lib/FormCssApi';

const PackageButton = ({ p, onClick, isSelected, layout}) => {
    return (
        <SelectItemButton
            onClick={onClick}
            isSelected={isSelected}
            layout={layout}
            image={p.image}
            rightContent={
                <>
                    {p.price > 0 && (
                        <div {...part(FormPart.SELECTION_PRICE)}>
                            {p.type === 'subscription' && (
                                <div className="@md:text-right leading-tight">
                                    <div>
                                        {formatCurrency(p.price) +
                                            ' ' +
                                            humanRenewalPeriod(
                                                p.subscription_settings
                                                    ?.renewalPeriod,
                                            )?.toLowerCase()}
                                    </div>
                                    {parseFloat(
                                        p.subscription_settings?.setupFee,
                                    ) !== 0 && (
                                        <div>
                                            {p.subscription_settings?.setupFee >
                                                0 && (
                                                <>
                                                    +
                                                    {formatCurrency(
                                                        p.subscription_settings
                                                            ?.setupFee,
                                                    )}{' '}
                                                    initial fee
                                                </>
                                            )}
                                            {p.subscription_settings?.setupFee <
                                                0 && (
                                                <>
                                                    {formatCurrency(
                                                        p.subscription_settings
                                                            ?.setupFee,
                                                    )}{' '}
                                                    off first payment
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                            {p.type !== 'subscription' &&
                                formatCurrency(p.price)}
                        </div>
                    )}
                </>
            }
        >
            <div className="font-semibold leading-tight">{p.name}</div>
            {!!p.description && (
                <div className="whitespace-pre-line text-gray-500 text-sm">
                    {p.description}
                </div>
            )}
        </SelectItemButton>
    );
};

const PackagesQuestion = ({ label, settings, value, setValue }) => {
    const { data, isLoading } = usePublicPackagesQuery();
    const selectedPackages = settings?.packages || [];
    const packages = (data?.packages || []).filter(p => {
        if (!selectedPackages.length) {
            return true;
        }

        return selectedPackages.indexOf(p.id) > -1;
    });

    value = value || [];

    function togglePackage(p) {
        const idx = value.findIndex(pv => pv.id === p.id);
        if (idx >= 0) {
            // Remove
            const newValue = [...value];
            newValue.splice(idx, 1);
            setValue(newValue);
        } else {
            // Only one package can be selected at a time
            setValue([
                //...value,
                {
                    id: p.id,
                },
            ]);
        }
    }

    function isSelected(p) {
        return value.findIndex(pv => pv.id === p.id) >= 0;
    }

    useEffect(() => {
        // If this question is required, nothing is selected, and there's only 1 option
        // then automatically select it
        if (settings?.required && !value.length && packages?.length === 1) {
            togglePackage(packages[0]);
        }
    }, [packages?.length]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div
            className={
                settings?.isError ? 'border-l-2 border-red-600 pl-4' : ''
            }
        >
        <div className="@container">
            <QuestionLabel label={label} settings={settings} />
            <div
                className={`${settings.layout === 'grid' ? 'grid grid-cols-2 gap-4' : ''}`}
            >
                {packages.map((p, idx) => {
                    return (
                        <PackageButton
                            key={idx}
                            p={p}
                            onClick={() => {
                                togglePackage(p);
                            }}
                            isSelected={isSelected(p)}
                            layout={settings?.layout}
                        />
                    );
                })}
            </div>
        </div>
        </div>
    );
};

export default PackagesQuestion;
